<template>
  <div>
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules"
        :loading="loading">
      <vxe-form-item span="24">
        <template>
          <div style="margin-left: 37px">
            <span>
            申请人:{{ formData.applyUser }}
            </span>
            <span style="margin-left: 30px">
              联系方式:{{ formData.applyUserPhone }}
            </span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="审核结果:" field="status" span="24">
        <template>
          <vxe-radio-group v-model="formData.status" @change="changeStatus">
            <vxe-radio :label="1" content="通过"></vxe-radio>
            <vxe-radio :label="2" content="未通过"></vxe-radio>
          </vxe-radio-group>
        </template>
      </vxe-form-item>
      <vxe-form-item v-if="formData.status === 2" title="驳回原因:"
                     field="remark" span="24">
        <template>
          <vxe-textarea v-model="formData.remark" size="medium"></vxe-textarea>
        </template>
      </vxe-form-item>
      <vxe-form-item align="right" span="24">
        <template>
          <vxe-button type="submit" @click="close">取消</vxe-button>
          <vxe-button type="submit" status="primary" @click="auditUserShipAuth">确定</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>

import {hideLoading, showLoading} from "@/utils/util";
import $api from "@/apiProvider";

export default {
  data() {
    return {
      formRules: {
        status: [
          {required: true, message: "请选择审核结果"},
        ],
        remark: [
          {required: true, message: "请输入驳回原因"},
        ],
      },
      formData: {},
      loading: false,
      id: null
    }
  },
  methods: {
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    init(id) {
      this.id = id;
      this.queryShipDetailNew();
    },
    changeStatus(e) {
      this.$set(this.formData, 'status', e.label);
    },
    async queryShipDetailNew() {
      showLoading();
      let res = await $api.carShip.request('queryShipDetailNew', {
        id: this.id
      });
      hideLoading();
      if (res.status === 1) {
        this.formData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async auditUserShipAuth() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      showLoading();
      let res = await $api.carShip.request('auditUserShipAuth', {
        id: this.id,
        remark: this.formData.remark,
        status: this.formData.status
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('审核成功');
        this.$emit('afterAuth');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>

<style scoped>

</style>